import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useNavigate } from "react-router-dom";

const apiKey = process.env.REACT_APP_API_KEY;
const apiUrl = process.env.REACT_APP_API_URL;

const UpiPayment = () => {
  const location = useLocation();
  const booking = location.state?.booking;
  const navigate = useNavigate();
  const [status, setStatus] = useState(booking?.status || "PENDING_PAYMENT");
  const [paidButtonEnabled, setPaidButtonEnabled] = useState(false);
  const [countdown, setCountdown] = useState(5); // countdown timer

  // Countdown to enable "I Have Paid"
  useEffect(() => {
    if (!paidButtonEnabled && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      setPaidButtonEnabled(true);
    }
  }, [countdown, paidButtonEnabled]);
  const handleIPaid = async () => {

    try {
        console.log(booking.UTR);
      const res = await fetch(`${apiUrl}/booking/markPaid`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "API_KEY": apiKey,
        },
        body: JSON.stringify({
            bookingId: booking.bookingId,
            utr: booking.utr, // use directly from booking object
          }),
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText || "Payment update failed");
      }

      setStatus("PAYMENT_SUBMITTED");
      navigate("/booking-confirmation", { state: { booking: booking } });
    } catch (err) {
      console.error(err);
      alert(`Failed to update payment status: ${err.message}`);
    }
  };

  if (!booking) {
    return <p className="text-center mt-20 text-red-500">No booking found</p>;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-indigo-100 p-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-6 space-y-6 border border-indigo-200">
        <h2 className="text-2xl font-bold text-center text-indigo-700">Complete Your Payment</h2>

        <div className="bg-indigo-50 rounded-xl p-4 space-y-2">
          <p className="font-semibold text-indigo-700">
            Booking ID: <span className="font-normal">{booking.bookingId}</span>
          </p>
          <p className="font-semibold text-indigo-700">
            Ground: <span className="font-normal">{booking.groundName}</span>
          </p>
          <p className="font-semibold text-indigo-700">
            Date & Slot: <span className="font-normal">{booking.slotBookingDateTime}</span>
          </p>
          <p className="font-semibold text-indigo-700">
            Amount: <span className="font-normal">₹{booking.amount}</span>
          </p>
          <p className="font-semibold text-indigo-700">
            Status: <span className="font-normal">{status}</span>
          </p>
        </div>

        {/* QR Code */}
        <div className="flex flex-col items-center space-y-4">
          <p className="text-center text-indigo-600 font-semibold">Scan QR to Pay via UPI</p>
          <QRCodeSVG value={booking.upiLink} width={200} height={200} fgColor="#4ade80" bgColor="#ffffff" />
        </div>

    

        {/* I Have Paid Button */}
        <button
          onClick={handleIPaid}
          disabled={!paidButtonEnabled || status === "PAYMENT_SUBMITTED"}
          className={`w-full py-3 rounded-2xl font-semibold shadow transition duration-200 ${
            paidButtonEnabled ? "bg-blue-600 text-white hover:bg-blue-700" : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
        >
          {paidButtonEnabled ? "I Have Paid" : ""}
        </button>

        <p className="text-center text-sm text-indigo-400 mt-2">
          Tip: Scan the QR code and complete the payment in your UPI app before entering the UTR.
        </p>
      </div>
    </div>
  );
};

export default UpiPayment;